import Vue from 'vue';
import Vuex from 'vuex';
import BootstrapVue from 'bootstrap-vue';
import App from './App.vue';
import router from './router';

import store from './store';

import HighchartsVue from 'highcharts-vue';
import Highcharts from 'highcharts';
import mapInit from 'highcharts/modules/map';
import sankey from 'highcharts/modules/sankey';
import brokenAxis from 'highcharts/modules/broken-axis'
import boost from "highcharts/modules/boost";
import VueHtmlToPaper from 'vue-html-to-paper';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import './assets/main.css';

Vue.use(Vuex)
Vue.use(VueHtmlToPaper)

mapInit(Highcharts);
sankey(Highcharts);
brokenAxis(Highcharts);
// boost(Highcharts);

Vue.use(HighchartsVue);

Vue.config.productionTip = false;
Vue.use(BootstrapVue);

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app');
